export const HAS_UNINTEGRATED_CHANGES_QUERY_KEY = 'hasUnintegratedChanges';
